import React, { useEffect, useState } from 'react';
import {Grid, Box, Modal, Typography, Button, FormControl, LinearProgress, TextField} from "@mui/material";
import { styles } from "./styles";
import CloseIcon from '@mui/icons-material/Close';
import MuiSelect from "components/MuiSelect/MuiSelect";
import {getRolePermissions, editRoleApi, deleteRole} from "apis/user";
import SwitchGroup from './SwitchGroup';
import { Colors } from 'assets/colors';
import DeleteModal from "../../../common/DeleteModal";
import ToastManager from "../../../common/ToastManager";
import CommonUtil from "../../../common/CommonUtil";
import TruckMuiSelect from "../../MuiSelect/TruckMuiSelect";
import {removeFalseItems} from "./commonUtil";


interface EditRoleProps {
  open: boolean;
  handleClose: Function | any;
  roleToEdit: any;
  getRoles: Function;
}

interface InputType {
  type: string,
  placeholder: string,
  disabled?: boolean,
  label?: string,
  size: number,
  value: string | undefined,
  key: string
}

const EditRoleModal: React.FC<EditRoleProps> = ({ open, handleClose, roleToEdit, getRoles }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [permissions, setPermissions] = useState<any>([]);

  const [filtered, setFiltered] = useState<any>([]);
  const [modules, setModules] = useState<any>([]);
  const [err, setErr] = useState("");
  const [disabledPageIds, setDisabledPageIds] = useState<any>([]);
  const [disabledModuleIds, setDisabledModuleIds] = useState<any>([]);
  const [currentStatus, setCurrentStatus] = useState(roleToEdit.roleStatus);
  const [roleDescription, setRoleDescription] = useState(roleToEdit.roleDescription);
  const [delRole,setDeleteRole] = useState(false);

  const [roleName, setRoleName] = useState(roleToEdit.roleName);
  const [roleNameErr, setRoleNameErr] = useState(false);

  const [truckStatuses,setTruckStatuses] = useState<any>(CommonUtil.statuses);
  const [status,setStatus] = useState<any>({key:roleToEdit.roleStatus,value:roleToEdit.roleStatus});
  const [statusError,setStatusError] = useState(false);


  const handleEdit = async () => {
    let finalPermissions = [...filtered];

    if(!roleName && !status){
      setRoleNameErr(true);
      setStatusError(true);
    }else if(!roleName){
      setRoleNameErr(true);
    }else if(!status){
      setStatusError(true);
    }else if(roleName && status){
      if(roleName.length > 64) {
        setErr("Role name can only contain 64 characters.");
        return
      }
      if(roleDescription && roleDescription.length > 128) {
        setErr("Role description can only contain 128 characters.");
        return
      }
      // if (disabledModuleIds.length > 0) {
      //   finalPermissions = finalPermissions.filter((f: any) => !disabledModuleIds.includes(f.moduleName))
      // }
      // if (disabledPageIds.length > 0) {
      //   finalPermissions = finalPermissions.filter((f: any) => !disabledPageIds.includes(f.masterPermissionId))
      // }

      let newPermissions: any = finalPermissions.map((f: any) => {
        return {
          masterPermissionId: f.masterPermissionId,
          canAdd: f.canAdd !== undefined ? f.canAdd : f.addPermission,
          canEdit: f.canEdit !== undefined ? f.canEdit : f.editPermission,
          canDelete: f.canDelete !== undefined ? f.canDelete : f.deletePermission,
        }
      })
      let submitObj = {
        applicationName: roleToEdit.applicationName,
        roleName: roleName,
        rolePermissions: removeFalseItems(newPermissions),
        roleStatus: status?status.value:"",
        roleDescription: roleDescription
      }
      setIsLoading(true);
      try {
        let data = await editRoleApi(roleToEdit.roleId, submitObj);
        if (data?.response?.data?.errorMessage) {
          setIsLoading(false);
          ToastManager.showToast(data.response.data.errorMessage,"Error");
          //setErr(data.response.data.errorMessage);
          return
        }
        if (data) {
          setIsLoading(false);
          getRoles();
          handleClose();
          ToastManager.showToast("Role Updated Successfully","Success");
        }
      } catch (e) {
        console.log(e);
      }
    }


  }

  const getPermissions = async () => {
    setIsLoading(true);
    let data = await getRolePermissions();
    if (data) {
      setPermissions(data);
      const combinedArray = roleToEdit.rolePermissions.map((item1: any) => {
        const matchingItem = data.find((item2: any) => item2.masterPermissionId === item1.masterPermissionId);
        return {
          ...item1,
          ...matchingItem
        };
      });
      setIsLoading(false);

      for (const d of data) {
        if (d.applicationName === roleToEdit.applicationName &&
          !combinedArray.some((permission: any) => permission.masterPermissionId === d.masterPermissionId)) {
          let newObj = {
            ...d,
            canAdd: false,
            canEdit: false,
            canDelete: false,
          }
          combinedArray.push(newObj);
        }
      }
      setFiltered(combinedArray);
    }
  }

  useEffect(() => {
    getPermissions();
  }, []);

  useEffect(() => {
    if (filtered.length > 0) {
      let unique = filtered.map((item: any) => item.moduleName)
        .filter((value: any, index: number, self: any) => self.indexOf(value) === index);
      setModules(unique);
    }
  }, [filtered]);


  const handleRoleNameChange = (val: string, key: string) => {
    if(key === "name") {
      setRoleName(val);
    }
    if(key === "description") {
      setRoleDescription(val);
    }
    if (err !== "") {
      setErr("");
    }
  }

  const returnInput = (params: InputType) => {
    let { type, placeholder, disabled, label, value, key } = params;
    return (
      <Grid item xs={params.size} sx={styles.inputContainer}>
        {label && <Typography sx={styles.label}>{label}</Typography>}
        {type === "input" ?
          <>
            <input
              type="text"
              placeholder={placeholder}
              style={{ ...styles.input }}
              disabled={disabled ? disabled : false}
              value={value}
              onChange={(e: any) => handleRoleNameChange(e.target.value, key)}
            />
          </>
          :
          <textarea style={styles.textarea} placeholder={placeholder}></textarea>
        }
      </Grid>
    )
  }

  const updateRoleList = (id: number, updatedProperties: any) => {
    let list = [...filtered];
    for (let i = 0; i < list.length; i++) {
      if (list[i].masterPermissionId === id) {
        list[i] = {
          ...list[i],
          ...updatedProperties,
        };
      }
    }
    setFiltered(list);
  };

  const updatePageRoleList = (id: number, value: boolean) => {
    if (value === false) {
      setDisabledPageIds([...disabledPageIds, id]);
    } else {
      let remove = [...disabledPageIds];
      remove.splice(remove.indexOf(id), 1);
      setDisabledPageIds(remove);
    }
    let list = [...filtered];
    for (let i = 0; i < list.length; i++) {
      if (list[i].masterPermissionId === id) {
        // Update the object with the matching id
        list[i] = {
          ...list[i],
          canAdd: value,
          canEdit: value,
          // canDelete: value,
        };
        break;
      }
    }
    setFiltered(list);
  };

  const updateModuleRoleList = (module: string, value: boolean) => {
    if (value === false) {
      setDisabledModuleIds([...disabledModuleIds, module]);
    } else {
      let remove = [...disabledModuleIds];
      remove.splice(remove.indexOf(module), 1);
      setDisabledModuleIds(remove);
    }
    let list = [...filtered];
    for (let i = 0; i < list.length; i++) {
      if (list[i].moduleName === module) {
        // Update the object with the matching id
        list[i] = {
          ...list[i],
          masterPermissionId: list[i].masterPermissionId,
          canAdd: false,
          canEdit: false,
          // canDelete: value,
        };
      }
    }
    setFiltered(list);
  }

  const returnSelect = (params: any) => {
    let { size, value, options, onChange } = params;
    return (
      <Grid item xs={size} sx={{ marginBottom: 0 }}>
        <MuiSelect
          value={value}
          options={options}
          onChangeHandler={(val: any) => onChange(val)}
        />
      </Grid>
    )
  };

  const handleDelete = ()=>{
    setDeleteRole(true);
  }

  const handleDeleteRole = (role:any) =>{
    console.log(role);
    if (role !== null) {
      deleteSelectRole(role);
    }
  }

  const deleteSelectRole = async(role:any)=>{
    let data = await deleteRole(role.roleId);
    if (data?.response?.data?.errorMessage) {
     // setIsLoading(false);
      //setErr(data.response.data.errorMessage);
      ToastManager.showToast(data.response.data.errorMessage,"Error");
      return
    }

    if (data) {
      setIsLoading(false);
      handleClose(false);
      getRoles();
    }


  }

  const handlePopupClose = (flag:boolean)=>{
    setDeleteRole(flag);
  }

  let onChangeRoleName = (e:any)=>{
    setRoleName(e);
    if(e){
      setRoleNameErr(false);
    }else{
      setRoleNameErr(true);
    }
  }
  let onChangeStatus = (data:any)=>{
    setStatus(data);
    if(data){
      setStatusError(false);
    }else{
      setStatusError(true);
    }
  }

  let onChangeDescription = (e:any)=>{
    setRoleDescription(e);
  }



  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <>
        {delRole && <DeleteModal title={"Delete Role"} open={delRole} handleDelete={handleDeleteRole} handlePopupClose={setDeleteRole} role={roleToEdit} getList={getRoles} />}
        <Box sx={styles.container}>
        {isLoading && <LinearProgress sx={{ margin: ".5rem 0" }} />}

          <Grid item xs={12} sx={styles.header}>
            <h2>Edit Role</h2>
            <CloseIcon onClick={() => handleClose(false)} />
          </Grid>
          <Grid item xs={12}>
            <Typography sx={styles.subHeader} style={{fontWeight:"bold",marginTop:"0px",marginBottom:"20px"}}>Role Details</Typography>
            {err && <Typography sx={styles.err}>{err}</Typography>}
            <Grid container spacing={2} sx={styles.subContainer}>
              {/*returnInput({ type: "input", placeholder: "Role Name", size: 6, value: roleName, key: "name" })*/}
              <Grid item xs={6}>
                <TextField style={{width:"100%",paddingBottom:"0px"}}  label={"Role Name"}  value={roleName} inputProps={{ maxLength: 60 }}
                           onChange={(e) => onChangeRoleName(e.target.value)} required={true} error={roleNameErr} />
              </Grid>
              <Grid item xs={6} sx={{ marginBottom: 0 }}>
                <TruckMuiSelect label={"Status"} sKey={"key"} value={"value"} selectedValue={status}  dataSource={truckStatuses}
                                mandatory={true} iserror={statusError} onChangeHandler={(e: any) => onChangeStatus(e)} />
              </Grid>
              {/*returnSelect({ size: 6, options: ["Active", "Inactive"], value: currentStatus, onChange: setCurrentStatus })*/}
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid item xs={12} sx={{ marginBottom: 0 }}>
              <TextField style={{width:"100%",paddingBottom:"0px"}}   label={"Role Description"}  inputProps={{ maxLength: 120 }} value={roleDescription}
                         onChange={(e) => onChangeDescription(e.target.value)} required={false} error={false} multiline={true} />
            {/*returnInput({ type: "input", placeholder: "Role Description", size: 12, value: roleDescription, key: "description" })*/}
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2} sx={styles.subContainer}>
              <Typography style={{fontWeight:"bold"}} sx={{ ...styles.subHeader, paddingLeft: "1rem", marginBottom: 0 }}>Application: {roleToEdit.applicationName}</Typography>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            {modules.length > 0 &&
              modules.map((m: any, i: number) =>
                <SwitchGroup
                  key={i}
                  roleData={m}
                  data={filtered}
                  switchChange={updateRoleList}
                  pageChange={updatePageRoleList}
                  updateModule={updateModuleRoleList}
                  isEdit={true}
                />
              )
            }
          </Grid>
          <Grid item xs={12} sx={styles.buttonContainer}>
            <Button sx={styles.cancelButton} onClick={() => handleClose(false)}>Cancel</Button>
            {CommonUtil.isScreenButtonAvailable(CommonUtil.ROLES,CommonUtil.UPDATE_MODE)?<Button sx={styles.deleteButton} onClick={() => handleDelete()}>Delete Role</Button>:""}
            {CommonUtil.isScreenButtonAvailable(CommonUtil.ROLES,CommonUtil.UPDATE_MODE)?<Button sx={styles.addButton} onClick={() => handleEdit()}>Edit Role</Button>:""}
          </Grid>
        </Box>
      </>
    </Modal>
  )
}

export default EditRoleModal;
